import { useIsAnyMobileState } from '@/stores/responsive.store';
import { memo } from 'react';
import { useCreateTicketModal } from './use-create-ticket-modal';
import { Modal } from '@/components/_ui/modal';
import DekstopCreateTicketForm from './desktop-create-ticket-form';
import MobileCreateTicketForm from './mobile-create-ticket-form';
import TimeFrameModal from '@/components/ui/timeframe-modal';

export type TCreateTicketModalType = 'CreateTicketModal';
export interface ICreateTicketModalProps {
  triggerFrom?: 'case' | 'space';
  caseId?: string;
  spaceId?: string;
  spaceColumnId?: string;
  position?: string;
}
const CreateTicketModal = memo(
  ({ triggerFrom = 'space', caseId, spaceId, spaceColumnId, position }: ICreateTicketModalProps) => {
    const isAnyMobile = useIsAnyMobileState();
    const createTicketModalHookState = useCreateTicketModal({ triggerFrom, caseId, spaceId, spaceColumnId, position });

    if (isAnyMobile) {
      return (
        <>
          <Modal
            className="p-0 w-[365px] h-fit overflow-hidden"
            closeButtonClassName="top-[12px] right-[12px]"
            isCloseOutside={true}
            isButtonClose={true}
            isOpen={createTicketModalHookState.isCreateTicketOpen}
            onClose={createTicketModalHookState.handleCloseModal}
            lockBodyScroll
          >
            <MobileCreateTicketForm {...createTicketModalHookState} />
          </Modal>
          <TimeFrameModal
            submitText="Apply Date"
            title="Set Due date"
            initialDateRange={createTicketModalHookState.dateValues ?? undefined}
            isOpen={createTicketModalHookState.isOpenDateModal}
            onClose={() => {
              createTicketModalHookState.handleCloseDateModal();
            }}
            onApply={(dateRange) => {
              createTicketModalHookState.form.setValue('startDate', dateRange?.from?.toISOString());
              createTicketModalHookState.form.setValue('endDate', dateRange?.to?.toISOString());
              createTicketModalHookState.handleSetDateValuesModal(dateRange);
              createTicketModalHookState.handleCloseDateModal();
            }}
          />
        </>
      );
    }

    return (
      <>
        <Modal
          className="p-0 max-w-[1080px] w-full h-fit overflow-hidden gap-0 max-h-[78vh]"
          isCloseOutside={true}
          isButtonClose={true}
          isOpen={createTicketModalHookState.isCreateTicketOpen}
          onClose={createTicketModalHookState.handleCloseModal}
          closeButtonClassName="top-[12px] right-[12px]"
          lockBodyScroll
        >
          <DekstopCreateTicketForm {...createTicketModalHookState} />
        </Modal>
        <TimeFrameModal
          submitText="Apply Date"
          title="Set Due date"
          initialDateRange={createTicketModalHookState.dateValues ?? undefined}
          isOpen={createTicketModalHookState.isOpenDateModal}
          onClose={() => {
            createTicketModalHookState.handleCloseDateModal();
          }}
          onApply={(dateRange) => {
            createTicketModalHookState.form.setValue('startDate', dateRange?.from?.toISOString());
            createTicketModalHookState.form.setValue('endDate', dateRange?.to?.toISOString());
            createTicketModalHookState.handleSetDateValuesModal(dateRange);
            createTicketModalHookState.handleCloseDateModal();
          }}
        />
      </>
    );
  }
);
CreateTicketModal.displayName = 'CreateTicketModal';
export default CreateTicketModal;
